export default __webpack_public_path__ + "static/media/banner2.57066a82.png";